import axios from 'axios';
import { API_URL } from './api';

export const kernelService = {
    getCountries () {
        console.log('kernelService: getCountries');

        return axios
            .get(`${API_URL}/landen`)
            .then((response) => {
                if (response.data.data)
                {
                    return response.data.data;
                }

                return response;
            });
    },

    getAissen () {
        console.log('kernelService: getAissen');

        return axios
            .get(`${API_URL}/aissen`)
            .then((response) => {
                if (response.data.data)
                {
                    return response.data.data;
                }

                return response;
            });
    },

    ping () {
        console.log('kernelService: ping');

        return axios
            .get(`${API_URL}/apitest`)
            .then((response) => response);
    },
};

export default kernelService;
